import Vue from "vue";
import TrainFormatterUtils from "@views/train-manager/utils/TrainFormatterUtils";

/**
 * 计划培训状态
 */
Vue.filter("formatterTrainingState", function (val) {
    return TrainFormatterUtils.formatterTrainingState(val);
});
